import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Container, ContentRow, Header } from '@src/components/Atoms/Modal';
import ModalContainer from '@src/components/Molecules/ModalContainer';
import CMButton from '@src/components/Atoms/CMButton';
import CMText from '@src/components/Atoms/CMText';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
  width?: number;
  height?: number;
  title: string;
  content?: string;
}

const ConfirmModal = ({
  title,
  onClose,
  onConfirm,
  width,
  height,
  content,
}: Props) => {
  const theme = useTheme();

  return (
    <ModalContainer
      width={480}
      height={260}
      onClose={onClose}
      stopPropagation={(e) => {
        e.stopPropagation();
      }}
      backgroundColor={theme.commonColor.white}
    >
      <Container>
        <Header>
          <HeaderTitle fontSize={22} fontWeight={700}>
            {title}
          </HeaderTitle>
        </Header>
        <Content>
          <HeaderDescription>{content}</HeaderDescription>
        </Content>
        <ContentRow
          alignItems="center"
          justifyContent="center"
          padding="20px 0"
        >
          <CMButton
            onClick={onClose}
            backgroundColor="#fff"
            borderRadius={51}
            borderColor="#fff"
            color="#FF6969"
            hoverColor="#FF6969"
            style={{
              marginRight: '10px',
            }}
          >
            취소
          </CMButton>
          <CMButton
            onClick={onConfirm}
            borderRadius={51}
            backgroundColor="#FF6969"
            borderColor="#FF6969"
            color="#fff"
          >
            확인
          </CMButton>
        </ContentRow>
      </Container>
    </ModalContainer>
  );
};

const HeaderTitle = styled(CMText)``;
const HeaderDescription = styled(CMText)`
  color: ${({ theme }) => theme.commonColor.gray005};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
`;

export default ConfirmModal;
